import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormControl, FormControlName, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-escalation-edit-custom',
  templateUrl: './escalation-edit-custom.component.html',
  styleUrls: ['./escalation-edit-custom.component.scss']
})
export class EscalationEditCustomComponent implements OnInit {

  @Input() escalation:any = null;
  @Input() type:any = null;
  @Input() id:any = null;
  @Output() completed = new EventEmitter<boolean>();

  path = "escalation/company";

  formGroup  = new FormGroup ({
    text: new FormControl('',[]),
  });

  submitted = false;

  get f(): { [key: string]: AbstractControl } {
    return this.formGroup.controls;
  }


  constructor(public okService: OkAloneService) { }

  ngOnInit(): void {

    //console.log("type",this.type,"id",this.id);

    if(this.type == "worker"){
      this.path = "escalation/worker/"+this.id;
    }else if(this.type == "group"){
      this.path = "escalation/group/"+this.id;
    }

    this.setupForm();

  }

  setupForm(){
    if(this.escalation.json.text){
      this.formGroup.setValue({
        text: this.escalation.json.text
      });
    }
  }

  submitForm(){

    this.submitted = true;
    if (
      this.formGroup.valid
      ) {
        let values = this.formGroup.value
        //console.log('form values',values);

        //console.log(this.path);
        

        this.okService.put(this.path,values)
        .subscribe((data) => {

          this.escalation = values;

          this.completed.emit(true);

        });

      }

    return false;

  }

  
  cancel(){
    this.completed.emit(false);
  }

}
